export default __webpack_public_path__ + "static/media/tom.60ad1963.jpg";